var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "#67678B",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.074 4.06l-.948-.947.66-.66c.562-.561.562-1.47.002-2.032-.561-.561-1.47-.561-2.032 0L6.52 8.658c-1.98-.984-4.38-.39-5.67 1.405s-1.09 4.26.472 5.823c1.563 1.563 4.028 1.763 5.823.473 1.794-1.29 2.39-3.692 1.405-5.67l2.804-2.804.572.572c.332.331.815.461 1.268.34.453-.122.807-.476.928-.929.121-.452-.008-.936-.34-1.267l-.572-.572 1.062-1.063.948.948c.519.496 1.336.496 1.855 0 .51-.513.51-1.342 0-1.854zM4.52 10.437c1.243 0 2.25 1.007 2.25 2.25 0 1.242-1.007 2.25-2.25 2.25s-2.25-1.008-2.25-2.25 1.008-2.249 2.25-2.249v-.001z",
    transform: "translate(-422 -466) translate(404 307) translate(18.261 159.405)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.9ac1dd814d4c8f34296a683cdec01cff.svg";
export { ForwardRef as ReactComponent };